import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export function useCreditPrompt() {
  const [showModal, setShowModal] = useState(false);
  const [modalCreditType, setModalCreditType] = useState("electrical");

  const promptBuyCredits = useCallback((creditType) => {
    setModalCreditType(creditType);
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => setShowModal(false), []);

  const buyCredits = useCallback(async (creditType) => {
    try {
      const res = await axios.post(`${API}/api/credits/purchase`, {
        credit_type: creditType,
        origin_url: window.location.origin,
      }, { withCredentials: true });
      if (res.data?.checkout_url) {
        window.location.href = res.data.checkout_url;
      }
    } catch {
      toast.error("Failed to start checkout — please try again");
    }
  }, []);

  return { showModal, modalCreditType, promptBuyCredits, closeModal, buyCredits };
}
